import { useQuery } from "@tanstack/react-query";
import Title from "../components/ui/Title";
import { findAllPetitesAnnonces } from "../lib/queries/petites-annonces-queries";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";
import Box from "../components/ui/Box";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { formatDate } from "../lib/helpers/date_helpers";
import { getCouleurPetiteAnnonce, getEtatPetiteAnnonce } from "../lib/helpers/petites_annonces_helpers";
import { Edit2 } from "lucide-react";
import { Skeleton } from "../components/ui/skeleton";
import ShowPetiteAnnonceButton from "../components/petites-annonces/ShowPetiteAnnonceButton";
import { ksPetitesAnnoncesQK } from "../lib/query-keys";
import PayerPetiteAnnonceButton from "../components/petites-annonces/PayerPetiteAnnonceButton";
import { EtatPetiteAnnonce } from "../lib/enums/etat-petite-annonce.enum";
import DeletePetiteAnnonceButton from "../components/petites-annonces/DeletePetiteAnnonceButton";

export default function PetitesAnnoncesPage() {
  const { data: petitesAnnonces } = useQuery({
    queryKey: [ksPetitesAnnoncesQK],
    queryFn: findAllPetitesAnnonces,
  });

  if (!petitesAnnonces) {
    return (
      <div className='flex flex-col gap-3'>
        <Skeleton className='h-[40px] w-[200px] mb-7' />
        <Skeleton className='h-[40px] w-full' />
        <Skeleton className='h-[40px] w-full' />
        <Skeleton className='h-[40px] w-full' />
        <Skeleton className='h-[40px] w-full' />
        <Skeleton className='h-[40px] w-full' />
        <Skeleton className='h-[40px] w-full' />
      </div>
    );
  }

  return (
    <>
      <Title>Petites annonces</Title>
      <div className='my-4 text-gray-600'>
        L'Abeille de France vous donne la possibilité de publier vos petites annonces dans la revue.
      </div>
      <Link to='/petites-annonces/publier'>
        <Button icon={<Edit2 size={16} />}>Publier une annonce dans l'Abeille de France</Button>
      </Link>
      <Box className='mt-4'>
        <Title order={3}>Mes petites annonces</Title>
        <div className='flex flex-col gap-4 mt-5'>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Date</TableHead>
                <TableHead>Première ligne</TableHead>
                <TableHead>Statut</TableHead>
                <TableHead className='text-right'>Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {petitesAnnonces.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} className='text-center text-gray-500'>
                    Vous n'avez pas encore publié d'annonces
                  </TableCell>
                </TableRow>
              ) : (
                petitesAnnonces.map((annonce) => (
                  <TableRow key={annonce.id}>
                    <TableCell>{formatDate(annonce.createdAt)}</TableCell>
                    <TableCell>{annonce.ligne1}</TableCell>
                    <TableCell>
                      <div className={`${getCouleurPetiteAnnonce(annonce.etat)} px-2 py-1 rounded-md w-max`}>
                        {getEtatPetiteAnnonce(annonce.etat)}
                      </div>
                    </TableCell>
                    <TableCell className='text-right'>
                      <div className='flex gap-2 justify-end'>
                        {annonce.etat === EtatPetiteAnnonce.AttentePaiement && (
                          <PayerPetiteAnnonceButton id={annonce.id} />
                        )}
                        <ShowPetiteAnnonceButton initialPetiteAnnonce={annonce} />
                        {annonce.etat === EtatPetiteAnnonce.AttentePaiement && (
                          <DeletePetiteAnnonceButton petiteAnnonce={annonce} />
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </div>
      </Box>
    </>
  );
}
